<template>
  <div class="main-content-container container-fluid px-4">
    <page-header title="Add" subtitle="Team Member"/>

    <d-row>
      <d-col>
        <d-card class="card elevation-z3">
          <d-card-body>
            <form id="add-team-member-form" @submit.prevent="addMember">
              <vue-form-generator  :schema="schema" :model="member" :options="formOptions" />
            </form>
            <input type="submit" form="add-team-member-form" value="save" class="btn btn-primary">
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </div>
</template>


<script>
import {DEFAULT_MEMBER_MODEL, NEW_MEMBER_SCHEMA, MEMBER_OPTIONS} from './schema'
import { removeEmptyProperties } from '@/helpers'

export default {
  data() {
    return {
      member: DEFAULT_MEMBER_MODEL,
      schema: NEW_MEMBER_SCHEMA,
      formOptions: MEMBER_OPTIONS
    }
  },
  methods: {
    addMember() {
      const newMember = removeEmptyProperties(this.member)
      this.$store.dispatch("team/createMember", newMember)
      .then(response => {
        this.$router.push({ name: 'team' })
      })
    }
  },
};
</script>


<style scoped>
.action-btn {
  font-size: 1rem;
}
</style>